import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';

import type { ChatbotResponse, CreateChatbotParams } from './types';

export async function createChatbot({ artistId }: CreateChatbotParams): Promise<ChatbotResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/chatbot`;
  const response = await api.executePostRequest<ChatbotResponse>(url, {});

  return response.data;
}

export function useCreateChatbot() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createChatbot,
    onSuccess: (_, { artistId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistChatbot(artistId),
      });
    },
  });

  const { mutateAsync, ...rest } = mutation;

  return {
    createChatbot: mutateAsync,
    ...rest,
  };
}
